var _path, _path2, _path3, _circle, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle3, _path12, _path13, _path14, _path15, _circle4, _circle5, _path16, _path17, _path18, _circle6, _path19, _circle7, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle8, _path28, _path29, _path30, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamAugmentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 806.632,
    height: 698.766,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554.462 215.99a79.828 79.828 0 1 1-79.686-79.97 79.621 79.621 0 0 1 79.686 79.97Z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m687.32 262.523 11.225-21.432c-10.065-12.155-43.088-26.896-43.088-26.896l-44.695-40.681a10.681 10.681 0 1 0-13.119 13.02l48.286 57.912Z",
    fill: "#9e616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m681.884 261.044 15.848 5.046a54.393 54.393 0 0 0 35.295-.786 19.641 19.641 0 0 0 12.686-16.398A19.595 19.595 0 0 0 729.4 227.7c-14.863-2.442-34.014-3.647-40.846 4.483l-.07.083Z",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 567.886,
    cy: 246.828,
    r: 79.828,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M535.307 215.603a75.004 75.004 0 0 1-5.351 17.08c-14.082 29.79 26.02 20.08 40.351 20.08 15.67 0 30.661 8.24 28.371-28.371-.978-15.639-12.702-28.372-28.37-28.372-13.385 0-32.202 5.95-35 19.583Z",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.96,
    cy: 229.701,
    r: 23.055,
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M552.303 206.2a26.409 26.409 0 0 1 40.15 23.048c-11.747 2.949-24.089 5.206-36.617.705l-2.959-7.24-1.744 7.245c-3.815 1.56-7.64 2.88-11.465-.015a26.965 26.965 0 0 1 12.635-23.743Z",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M629.956 299.908a79.8 79.8 0 0 1-111.684 8.072l6.847-19.106a20.546 20.546 0 0 1 17.451-11.984l4.356-.267 10.387-8.958s27.986-1 27.571-1.478l16.952 10.196-.014-.07 6.664.408a20.537 20.537 0 0 1 17.452 11.984Z",
    fill: "#38b2ac"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m560.882 628.845-1.983-27.589A89.244 89.244 0 0 0 517 591.861c20.432 15.793 18.795 47.357 32.945 68.96a53.68 53.68 0 0 0 40.028 23.72l17.004 9.783a89.952 89.952 0 0 0-20.944-72.346 86.888 86.888 0 0 0-16.368-14.395c-3.717 10.671-8.783 21.262-8.783 21.262ZM43.882 139.845 41.9 112.256A89.244 89.244 0 0 0 0 102.861c20.432 15.793 18.795 47.357 32.945 68.96a53.68 53.68 0 0 0 40.028 23.72l17.004 9.783a89.952 89.952 0 0 0-20.944-72.346 86.888 86.888 0 0 0-16.368-14.395c-3.717 10.671-8.783 21.262-8.783 21.262Z",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e616a",
    d: "m635.268 684.997-13.264-.001-6.31-51.159h19.576l-.002 51.16z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m638.65 697.854-42.767-.002v-.54a16.647 16.647 0 0 1 16.646-16.647h.001l7.812-5.926 14.576 5.927h3.733Z",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e616a",
    d: "m752.165 684.997-13.263-.001-6.31-51.159h19.576l-.003 51.16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m755.548 697.854-42.768-.002v-.54a16.647 16.647 0 0 1 16.647-16.647l7.813-5.926 14.575 5.927h3.734ZM731.992 411.186l11.156 105.98s14.85 106.117 12.062 120.76.697 16.733.697 16.733l-25.448-1.812s.697-9.064-3.486-13.248-2.092-16.733-2.092-16.733L675.516 450.23l-29.982 90.642s-4.88 99.705-5.578 101.1-2.789 20.22-2.789 20.22H611.37s3.486-11.156-1.394-14.642-9.064-.698-4.88-6.973 5.577-13.945 4.183-17.43-1.395-17.432-1.395-17.432 2.092-188.255 13.945-194.53 110.164 0 110.164 0Z",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.16,
    cy: 169.163,
    r: 27.439,
    fill: "#9e616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M741.475 422.737c-53.139 10.974-123.558-7.893-123.558-7.893l18.785-81.43-6.679-85.217c-.815-10.421 5.12-20.19 14.354-23.652l12.75-4.775 10.54-15.088 30.103.988 12.034 15.84 9.497 5.038 20.588 10.92.09.045v.045l-6.46 62.672-3.897 37.788s11.835 42.5 9.406 48.136c-2.428 5.628-.317 2.909.272 5.917.59 3.009 2.392 3.2 2.664 9.126.281 5.917-.489 21.54-.489 21.54Z",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M805.712 698.766h-410.47a.92.92 0 0 1 0-1.839h410.47a.92.92 0 0 1 0 1.839Z",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M677.826 195.284a84.515 84.515 0 0 0 14.346-1.376c4.686-1.08 15.027-9.076 17.845-13.8 2.094-3.509 3.35-8.938 4.037-12.873a37.78 37.78 0 0 0-7.38-29.812 11.936 11.936 0 0 0-4.925-3.989 5.894 5.894 0 0 0-.535-.164 14.726 14.726 0 0 1-7.44-4.343 12.147 12.147 0 0 0-1.25-1.221 18.14 18.14 0 0 0-7.663-3.604c-4.529-1.087-11.007.275-19.254 4.054-4.143 1.899-8.742 1.369-12.286.695a1.154 1.154 0 0 0-1.076.4 8.144 8.144 0 0 1-5.477 2.35c-1.258.087-2.535 1.865-4.074 4.181-.349.526-.756 1.14-1.052 1.514l-.06-.703-.692.804a9.883 9.883 0 0 0 4.876 15.98 19.272 19.272 0 0 0 3.891.518c.795.051 1.618.104 2.407.22a14.9 14.9 0 0 1 11.319 9.38 3.897 3.897 0 0 0 5.928 1.74 6.438 6.438 0 0 1 5.837-1.22 4.274 4.274 0 0 1 1.944 2.093 5.57 5.57 0 0 0 2.176 2.41c3.235 1.564 3.644 8.851 2.654 14.96-.954 5.888-3.03 10.184-5.047 10.445-1.554.202-1.729.317-1.835.595l-.094.25.181.226a6.364 6.364 0 0 0 2.699.29Z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M567.886 327.655a80.828 80.828 0 1 1 80.828-80.827 80.92 80.92 0 0 1-80.828 80.827Zm0-159.655a78.828 78.828 0 1 0 78.828 78.828A78.917 78.917 0 0 0 567.886 168Z",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.886,
    cy: 80.828,
    r: 79.828,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.581,
    cy: 62.94,
    r: 26.03,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "bf427902-b9bf-4946-b5d7-5c1c7e04535e",
    d: "M315.5 45.744s6.777-12.956-8.134-14.134c0 0-12.71-11.531-25.667-2.108 0 0-7.067 0-10.932 7.997 0 0-5.558-2.108-6.78 3.533 0 0-4.067 11.779 0 22.38s5.418 11.778 5.418 11.778-2.853-13.155 13.414-14.333 31.191-11.368 32.547 1.588 2.846 7.104 2.846 7.104 12.876-18.505-2.712-23.805Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.92 133.908a79.8 79.8 0 0 1-111.684 8.072l6.847-19.106a20.546 20.546 0 0 1 17.451-11.984l4.356-.267 10.387-8.958s27.986-1 27.57-1.478l16.953 10.196-.014-.07 6.664.408a20.537 20.537 0 0 1 17.452 11.984Z",
    fill: "#38b2ac"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.886 161.655a80.828 80.828 0 1 1 80.828-80.827 80.92 80.92 0 0 1-80.828 80.827Zm0-159.655a78.828 78.828 0 1 0 78.828 78.828A78.917 78.917 0 0 0 288.886 2Z",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.563,
    cy: 206.828,
    r: 79.828,
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.563 180.86c3.301-10.52 10.807-20.168 21.188-23.725 10.382-3.556 25.583 1.862 33.388 9.64 14.276 14.228 17.76 63.106 7.952 78.552-1.951-.104-8.683-.18-10.658-.254l-2.793-9.31v9.218q-4.719-.146-9.511-.201a41.393 41.393 0 0 1-40.867-40.371c-.255-10.246 0-19.404 1.301-23.55Z",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.379,
    cy: 192.974,
    r: 22.75,
    fill: "#9e616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m81.745 172.994 26.194-13.117a32.924 32.924 0 0 1 19.284 27.279l.653 7.82-10.97-2.792-1.2-10-1.864 9.22-5.062-1.288.048-15.526-5.065 15.515-18.08-4.154Z",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8 259.654a79.8 79.8 0 0 1-111.684 8.072l6.847-19.106a20.546 20.546 0 0 1 17.452-11.984l4.356-.267 10.386-8.958s27.987-1 27.571-1.478l16.953 10.197-.015-.07 6.664.407a20.537 20.537 0 0 1 17.452 11.984Z",
    fill: "#38b2ac"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.563 287.655a80.828 80.828 0 1 1 80.828-80.827 80.92 80.92 0 0 1-80.828 80.827Zm0-159.655a78.828 78.828 0 1 0 78.828 78.828A78.917 78.917 0 0 0 102.563 128Z",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m641.613 288.241-12.086-20.958c-15.655 1.988-45.792 21.978-45.792 21.978l-58.294 15.95a10.681 10.681 0 1 0 3.968 18.052l74.767-9.752Z",
    fill: "#9e616a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m637.452 292.04 27.057-22.663 3.936-18.242a19.641 19.641 0 0 0-7.052-19.496 19.595 19.595 0 0 0-26.645 2.415c-10.024 11.243-21.3 26.769-18.094 36.893l.033.103Z",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222.746 370.77H121.081a10.288 10.288 0 0 1-10.276-10.277v-62.616A10.288 10.288 0 0 1 121.08 287.6h101.665a10.288 10.288 0 0 1 10.277 10.277v62.616a10.288 10.288 0 0 1-10.277 10.277Z",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.353 362.704h-54.125a9.636 9.636 0 0 1-9.625-9.624v-47.79a9.636 9.636 0 0 1 9.625-9.625H215.6a9.635 9.635 0 0 1 9.625 9.625v14.543a42.92 42.92 0 0 1-42.872 42.871Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M206.884 321.834h-69.94a2.281 2.281 0 1 1 0-4.562h69.94a2.281 2.281 0 1 1 0 4.562ZM147.884 330.847h-10.94a2.281 2.281 0 0 1 0-4.562h10.94a2.281 2.281 0 1 1 0 4.562ZM167.261 339.86h-30.317a2.281 2.281 0 0 1 0-4.561h30.317a2.281 2.281 0 0 1 0 4.562Z",
    fill: "#38b2ac"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.257,
    cy: 286.353,
    r: 21.506,
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M486.746 86.77H385.081a10.288 10.288 0 0 1-10.276-10.277V13.877A10.288 10.288 0 0 1 385.08 3.6h101.665a10.288 10.288 0 0 1 10.277 10.277v62.616a10.288 10.288 0 0 1-10.277 10.277Z",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M446.353 78.704h-54.125a9.636 9.636 0 0 1-9.625-9.624V21.29a9.636 9.636 0 0 1 9.625-9.625H479.6a9.635 9.635 0 0 1 9.625 9.625v14.543a42.92 42.92 0 0 1-42.872 42.871Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M470.884 37.834h-69.94a2.281 2.281 0 1 1 0-4.562h69.94a2.281 2.281 0 1 1 0 4.562ZM411.884 46.847h-10.94a2.281 2.281 0 1 1 0-4.562h10.94a2.281 2.281 0 1 1 0 4.562ZM431.261 55.86h-30.317a2.281 2.281 0 0 1 0-4.561h30.317a2.281 2.281 0 0 1 0 4.562Z",
    fill: "#38b2ac"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.257,
    cy: 77.353,
    r: 21.506,
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAugmentation);
export default __webpack_public_path__ + "static/media/team-augmentation.c518fcf281f79eeb34c11d6d8c565dfb.svg";
export { ForwardRef as ReactComponent };